import { Link } from "react-router-dom";
import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  id: string;
  prospectPhone: string;
  messageCount: number;
  retentionUntil: string;
  createdAt: string;
};

export default function SmsPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ threads: Row[] }>("/api/v1/tenant/sms/threads");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("sms.title")}</h1>
      <DataTable
        rows={data?.threads ?? null}
        loading={loading}
        error={error}
        empty={t("sms.empty")}
        columns={[
          {
            header: t("sms.col.phone"),
            render: (r) => (
              <Link className="text-brand-700 hover:underline" to={`/admin/sms/threads/${r.id}`}>
                {r.prospectPhone}
              </Link>
            ),
          },
          { header: t("sms.col.messages"), render: (r) => r.messageCount },
          {
            header: t("sms.col.retention"),
            render: (r) => new Date(r.retentionUntil).toLocaleDateString(),
          },
          {
            header: t("sms.col.created"),
            render: (r) => new Date(r.createdAt).toLocaleDateString(),
          },
        ]}
      />
    </div>
  );
}
